import { render, staticRenderFns } from "./KnProductCategories.vue?vue&type=template&id=74d58d9c&"
import script from "./KnProductCategories.vue?vue&type=script&lang=js&"
export * from "./KnProductCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports